var map = {
	"./account.json": 98631,
	"./applyRefund.json": 58762,
	"./brand.json": 94633,
	"./common.json": 62605,
	"./commonHomeChannel.json": 8761,
	"./footer.json": 40131,
	"./home.json": 78463,
	"./luckseller.json": 93006,
	"./msg.json": 17781,
	"./order.json": 70064,
	"./payment.json": 79722,
	"./prod.json": 63729,
	"./refundDetail.json": 15667,
	"./register.json": 97253,
	"./returnLogistics.json": 79701,
	"./shopline.json": 14498,
	"./uploadFile.json": 53503
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77746;